import { mountStandaloneApp } from '@yuksalish/ui'
import { hrMessages } from './i18n'
import './styles.css'
import OverviewPage from './pages/OverviewPage.vue'
import EmployeesPage from './pages/EmployeesPage.vue'
import EmployeeFormPage from './pages/EmployeeFormPage.vue'
import EmployeeDetailPage from './pages/EmployeeDetailPage.vue'
import AttendancePage from './pages/AttendancePage.vue'
import AttendanceReportPage from './pages/AttendanceReportPage.vue'
import LeavePage from './pages/LeavePage.vue'
import OvertimePage from './pages/OvertimePage.vue'

const employeesView = 'employees.view'
const employeesCreate = 'employees.create'
const employeesUpdate = 'employees.update'
const attendanceView = 'attendance.view'
const timesheetsView = 'timesheets.view'

mountStandaloneApp({
  code: 'hr',
  title: {
    en: hrMessages.en.hr.appTitle,
    ru: hrMessages.ru.hr.appTitle,
    uz: hrMessages.uz.hr.appTitle,
  },
  description: {
    en: hrMessages.en.hr.appDescription,
    ru: hrMessages.ru.hr.appDescription,
    uz: hrMessages.uz.hr.appDescription,
  },
  accent: '#7b4e63',
  messages: hrMessages,
  requiredPermissions: [employeesView],
  navigation: [
    {
      label: {
        en: hrMessages.en.hr.nav.overview,
        ru: hrMessages.ru.hr.nav.overview,
        uz: hrMessages.uz.hr.nav.overview,
      },
      to: '/overview',
      permission: employeesView,
    },
    {
      label: {
        en: hrMessages.en.hr.nav.people,
        ru: hrMessages.ru.hr.nav.people,
        uz: hrMessages.uz.hr.nav.people,
      },
      to: '/employees',
      permission: employeesView,
      children: [
        {
          label: {
            en: hrMessages.en.hr.nav.employees,
            ru: hrMessages.ru.hr.nav.employees,
            uz: hrMessages.uz.hr.nav.employees,
          },
          to: '/employees',
          permission: employeesView,
        },
        {
          label: {
            en: hrMessages.en.hr.employees.newEmployee,
            ru: hrMessages.ru.hr.employees.newEmployee,
            uz: hrMessages.uz.hr.employees.newEmployee,
          },
          to: '/employees/new',
          permission: employeesCreate,
        },
      ],
    },
    {
      label: {
        en: hrMessages.en.hr.nav.time,
        ru: hrMessages.ru.hr.nav.time,
        uz: hrMessages.uz.hr.nav.time,
      },
      to: '/attendance',
      permission: attendanceView,
      children: [
        {
          label: {
            en: hrMessages.en.hr.nav.attendance,
            ru: hrMessages.ru.hr.nav.attendance,
            uz: hrMessages.uz.hr.nav.attendance,
          },
          to: '/attendance',
          permission: attendanceView,
        },
        {
          label: {
            en: hrMessages.en.hr.nav.attendanceReport,
            ru: hrMessages.ru.hr.nav.attendanceReport,
            uz: hrMessages.uz.hr.nav.attendanceReport,
          },
          to: '/attendance/report',
          permission: attendanceView,
        },
        {
          label: {
            en: hrMessages.en.hr.nav.leave,
            ru: hrMessages.ru.hr.nav.leave,
            uz: hrMessages.uz.hr.nav.leave,
          },
          to: '/leave',
          permission: attendanceView,
        },
        {
          label: {
            en: hrMessages.en.hr.nav.overtime,
            ru: hrMessages.ru.hr.nav.overtime,
            uz: hrMessages.uz.hr.nav.overtime,
          },
          to: '/overtime',
          permission: timesheetsView,
        },
      ],
    },
  ],
  routes: [
    { path: '', redirect: '/overview' },
    { path: 'overview', component: OverviewPage, meta: { permission: employeesView } },
    { path: 'employees', component: EmployeesPage, meta: { permission: employeesView } },
    { path: 'employees/new', component: EmployeeFormPage, meta: { permission: employeesCreate } },
    { path: 'employees/:id', component: EmployeeDetailPage, meta: { permission: employeesView } },
    { path: 'employees/:id/edit', component: EmployeeFormPage, meta: { permission: employeesUpdate } },
    { path: 'attendance', component: AttendancePage, meta: { permission: attendanceView } },
    { path: 'attendance/report', component: AttendanceReportPage, meta: { permission: attendanceView } },
    { path: 'leave', component: LeavePage, meta: { permission: attendanceView } },
    { path: 'overtime', component: OvertimePage, meta: { permission: timesheetsView } },
  ],
})
